"use strict";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCeloMethods = void 0;
var react_1 = require("react");
var react_device_detect_1 = require("react-device-detect");
var connectors_1 = require("./connectors");
var constants_1 = require("./constants");
var use_contracts_cache_1 = require("./hooks/use-contracts-cache");
var colors_1 = require("./utils/colors");
var logger_1 = require("./utils/logger");
var network_watcher_1 = __importDefault(require("./utils/network-watcher"));
var persistor_1 = __importDefault(require("./utils/persistor"));
var updater_1 = require("./utils/updater");
function useCeloMethods(_ref, dispatch, buildContractsCache) {
  var _this = this;
  var connector = _ref.connector,
    networks = _ref.networks,
    network = _ref.network,
    manualNetworkMode = _ref.manualNetworkMode;
  var initConnector = (0, react_1.useCallback)(function (nextConnector, lastUsedAddress) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var initialisedConnector, error;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            // need to set the event listeners here before initialise()
            (0, updater_1.updater)(nextConnector, dispatch);
            (0, persistor_1.default)(nextConnector);
            (0, network_watcher_1.default)(nextConnector, networks, manualNetworkMode);
            _context.next = 6;
            return nextConnector.initialise(lastUsedAddress);
          case 6:
            initialisedConnector = _context.sent;
            dispatch('initialisedConnector', initialisedConnector);
            _context.next = 19;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            if (!(typeof _context.t0 === 'symbol')) {
              _context.next = 15;
              break;
            }
            (0, logger_1.getApplicationLogger)().debug('[initConnector]', 'Ignoring error initializing connector with reason', _context.t0.description);
            throw _context.t0;
          case 15:
            (0, logger_1.getApplicationLogger)().error('[initConnector]', 'Error initializing connector', nextConnector.type, _context.t0);
            error = _context.t0 instanceof Error ? _context.t0 : new Error('Failed to initialise connector');
            dispatch('setConnectorInitError', error);
            throw _context.t0;
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }));
  }, [dispatch, networks, manualNetworkMode]);
  var disconnect = (0, react_1.useCallback)(function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var passiveConnector;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return connector.close();
          case 2:
            passiveConnector = new connectors_1.UnauthenticatedConnector(network);
            _context2.next = 5;
            return initConnector(passiveConnector);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  }, [connector, network, initConnector]);
  // This is just to be used to for users to explicitly change
  // the network. It doesn't work for all wallets.
  var updateNetwork = (0, react_1.useCallback)(function (newNetwork) {
    var dappOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            (0, logger_1.getApplicationLogger)().debug('[updateNetwork]', newNetwork, connector.type);
            if (!(dappOnly && connector.continueNetworkUpdateFromWallet)) {
              _context3.next = 5;
              break;
            }
            connector.continueNetworkUpdateFromWallet(newNetwork);
            _context3.next = 7;
            break;
          case 5:
            if (!constants_1.STATIC_NETWORK_WALLETS.includes(connector.type)) {
              _context3.next = 7;
              break;
            }
            throw new Error("The connected wallet's network must be changed from the wallet.");
          case 7:
            _context3.next = 9;
            return connector.startNetworkChangeFromApp(newNetwork);
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  }, [connector]);
  var connect = (0, react_1.useCallback)(function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var connectionResultPromise, newConnector;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            connectionResultPromise = new Promise(function (resolve) {
              dispatch('setConnectionCallback', resolve);
            });
            _context4.next = 3;
            return connectionResultPromise;
          case 3:
            newConnector = _context4.sent;
            dispatch('setConnectionCallback', null);
            if (!(newConnector === false)) {
              _context4.next = 7;
              break;
            }
            throw new Error('Connection cancelled');
          case 7:
            return _context4.abrupt("return", newConnector);
          case 8:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
  }, [dispatch]);
  var getConnectedKit = (0, react_1.useCallback)(function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var initialisedConnection;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            initialisedConnection = connector;
            if (!(connector.type === constants_1.WalletTypes.Unauthenticated)) {
              _context5.next = 7;
              break;
            }
            _context5.next = 4;
            return connect();
          case 4:
            initialisedConnection = _context5.sent;
            _context5.next = 10;
            break;
          case 7:
            if (initialisedConnection.initialised) {
              _context5.next = 10;
              break;
            }
            _context5.next = 10;
            return initConnector(initialisedConnection);
          case 10:
            return _context5.abrupt("return", initialisedConnection.kit);
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
  }, [connect, connector, initConnector]);
  var updateFeeCurrency = (0, react_1.useCallback)(function (newFeeCurrency) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            if (!(connector.supportsFeeCurrency() && connector.updateFeeCurrency)) {
              _context6.next = 5;
              break;
            }
            _context6.next = 4;
            return connector.updateFeeCurrency(newFeeCurrency);
          case 4:
            dispatch('setFeeCurrency', newFeeCurrency);
          case 5:
            _context6.next = 10;
            break;
          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            (0, logger_1.getApplicationLogger)().warn('[updateFeeCurrency]', 'updating Fee Currency not supported by this wallet or network', _context6.t0);
          case 10:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[0, 7]]);
    }));
  }, [connector, dispatch]);
  var updateTheme = (0, react_1.useCallback)(function (theme) {
    if (!theme) return dispatch('setTheme', null);
    if (process.env.NODE_ENV !== 'production') {
      (0, colors_1.fixTheme)(theme);
      (0, colors_1.contrastCheck)(theme);
    }
    dispatch('setTheme', theme);
  }, [dispatch]);
  var performActions = (0, react_1.useCallback)(function () {
    for (var _len = arguments.length, operations = new Array(_len), _key = 0; _key < _len; _key++) {
      operations[_key] = arguments[_key];
    }
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var kit, results, _i, _operations, op, url;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getConnectedKit();
          case 2:
            kit = _context7.sent;
            dispatch('setPendingActionCount', operations.length);
            results = [];
            _i = 0, _operations = operations;
          case 6:
            if (!(_i < _operations.length)) {
              _context7.next = 25;
              break;
            }
            op = _operations[_i];
            _context7.prev = 8;
            // When on mobile direct user to their wallet app.
            if (react_device_detect_1.isMobile && connector.getDeeplinkUrl) {
              url = connector.getDeeplinkUrl('');
              if (url) window.open(url, '_blank');
            }
            _context7.t0 = results;
            _context7.next = 13;
            return op(kit);
          case 13:
            _context7.t1 = _context7.sent;
            _context7.t0.push.call(_context7.t0, _context7.t1);
            _context7.next = 21;
            break;
          case 17:
            _context7.prev = 17;
            _context7.t2 = _context7["catch"](8);
            dispatch('setPendingActionCount', 0);
            throw _context7.t2;
          case 21:
            dispatch('decrementPendingActionCount');
          case 22:
            _i++;
            _context7.next = 6;
            break;
          case 25:
            return _context7.abrupt("return", results);
          case 26:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[8, 17]]);
    }));
  }, [getConnectedKit, dispatch, connector]);
  var contractsCache = (0, use_contracts_cache_1.useContractsCache)(buildContractsCache, connector);
  var resetInitError = (0, react_1.useCallback)(function () {
    dispatch('setConnectorInitError', null);
  }, [dispatch]);
  return {
    destroy: disconnect,
    disconnect: disconnect,
    initConnector: initConnector,
    resetInitError: resetInitError,
    updateNetwork: updateNetwork,
    connect: connect,
    getConnectedKit: getConnectedKit,
    performActions: performActions,
    updateFeeCurrency: updateFeeCurrency,
    contractsCache: contractsCache,
    updateTheme: updateTheme
  };
}
exports.useCeloMethods = useCeloMethods;